import { ClientEnvironment } from '@polyai/common/constants/global.constants';

import ENDPOINTS from 'api/endpoints';
import { doDelete, doGet, doPost } from 'api/request';
import type {
  AllTelephonyTokensResponse,
  TelephonyTokenResponse,
} from 'api/resources/telephony/types';
import { LOGGER_TYPE } from 'api/types';
import { generateNextPath } from 'lib/routeHelper';
import type { IntegrationsResponse } from 'screens/Integrations/types';

export const getConnectionToken = (accountId: string, projectId: string) => {
  return doGet<TelephonyTokenResponse>(
    generateNextPath(ENDPOINTS.TELEPHONY_TOKEN, { accountId, projectId }),
    LOGGER_TYPE.JUPITER,
    {
      params: {
        client_env: ClientEnvironment.SANDBOX,
      },
    },
  );
};

export const getAllConnectionTokens = (
  accountId: string,
  projectId: string,
) => {
  return doGet<AllTelephonyTokensResponse>(
    generateNextPath(ENDPOINTS.TELEPHONY_TOKENS, { accountId, projectId }),
    LOGGER_TYPE.JUPITER,
  );
};

export const createConnector = ({
  accountId,
  projectId,
  clientEnv,
}: {
  accountId: string;
  projectId: string;
  clientEnv: ClientEnvironment;
}) => {
  return doPost<TelephonyTokenResponse>(
    generateNextPath(ENDPOINTS.TELEPHONY_CONNECTOR, { accountId, projectId }),
    LOGGER_TYPE.JUPITER,
    {
      client_env: clientEnv,
    },
  );
};

export const getActiveTelephonyIntegrations = (
  accountId: string,
  projectId: string,
) => {
  return doGet<IntegrationsResponse[]>(
    generateNextPath(ENDPOINTS.TELEPHONY_GATEWAY_PROXY, {
      accountId,
      projectId,
    }),
    LOGGER_TYPE.JUPITER,
    { version: 'v2' },
  );
};

export const disconnectTelephonyIntegration = ({
  accountId,
  projectId,
  disconnectEndpoint,
}: {
  accountId: string;
  projectId: string;
  disconnectEndpoint: string;
}) => {
  return doDelete<void>(
    generateNextPath(disconnectEndpoint, { accountId, projectId }),
    LOGGER_TYPE.JUPITER,
    {},
    { version: 'v2' },
  );
};
